import {
  CLEAR_COLLECTED_ORDER,
  CLEAR_PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER_FULFILLED,
  PLACE_COLLECTED_ORDER_REJECTED,
  TOGGLE_COLLECTED_ORDER,
  UPDATE_COLLECTED_ORDER,
} from 'b2b-apps/shop/collectedOrder/redux/actionTypes';
import {
  ClearCollectedOrderAction,
  ClearPlaceCollectedOrderAction,
  PlaceCollectedOrderAction,
  PlaceCollectedOrderFulfilledAction,
  PlaceCollectedOrderRejectedAction,
  ToggleCollectedOrderAction,
  UpdateCollectedOrderAction,
} from 'b2b-apps/shop/collectedOrder/redux/types';
import {
  CollectedOrderDataType,
  PlaceCollectedOrderDataType,
} from 'b2b-common/core/collectedOrder/CollectedOrder.types';

const clearCollectedOrder = (): ClearCollectedOrderAction => ({
  type: CLEAR_COLLECTED_ORDER,
});

const clearPlaceCollectedOrder = (): ClearPlaceCollectedOrderAction => ({
  type: CLEAR_PLACE_COLLECTED_ORDER,
});

const placeCollectedOrder = (data: CollectedOrderDataType): PlaceCollectedOrderAction => ({
  type: PLACE_COLLECTED_ORDER,
  payload: {
    data,
  },
});

const placeCollectedOrderFulfilled = (data: PlaceCollectedOrderDataType): PlaceCollectedOrderFulfilledAction => ({
  type: PLACE_COLLECTED_ORDER_FULFILLED,
  payload: {
    data,
  },
});

const placeCollectedOrderRejected = (error: ErrorType): PlaceCollectedOrderRejectedAction => ({
  type: PLACE_COLLECTED_ORDER_REJECTED,
  payload: {
    error,
  },
});

const toggleCollectedOrder = (isEnabled?: boolean): ToggleCollectedOrderAction => ({
  type: TOGGLE_COLLECTED_ORDER,
  payload: {
    isEnabled,
  },
});

const updateCollectedOrder = (data: CollectedOrderDataType): UpdateCollectedOrderAction => ({
  type: UPDATE_COLLECTED_ORDER,
  payload: {
    data,
  },
});

export {
  clearCollectedOrder,
  clearPlaceCollectedOrder,
  placeCollectedOrder,
  placeCollectedOrderFulfilled,
  placeCollectedOrderRejected,
  toggleCollectedOrder,
  updateCollectedOrder,
};
